import React from 'react';
import { Dayjs } from 'dayjs';
import { DatePicker } from 'antd';
import './dateTimePickerComponent.scss';

interface Props {
  onChange: (value: Dayjs | null, dateString: string) => void;
  value: Dayjs | null;
  disabled: boolean;
}

export const DateTimePickerComponent: React.FC<Props> = (props) => {
  return (
    <DatePicker
      onChange={props.onChange}
      format='YYYY-MM-DD HH:mm'
      showTime
      allowClear={false}
      value={props.value}
      disabled={props.disabled}
    />
  );
};
